import React from "react";
import { Modal, Button } from "antd";
import { BsExclamationCircle } from "react-icons/bs";
import "../../../../styles/superAdmin/confirmlogin.css";
import { useDispatch } from "react-redux";
import { makeImpersonateModeFalse } from "../../../../redux/Admin/adminActions";
import { useLoginToAdmin } from "../../../../hooks/useImpersonate";

export default function ConfirmLoginModal({ open, selectedClient }) {
  const dispatch = useDispatch();

  const { mutate: loginToAdmin, isLoading } = useLoginToAdmin();

  const handleConfirm = async () => {
    console.log("[ConfirmModal] User confirmed action:");
    await loginToAdmin(selectedClient.id);
  };

  const handleCancel = () => {
    dispatch(makeImpersonateModeFalse());
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={420}
      className="confirm-modal"
      destroyOnClose
      centered
      closable={false}
    >
      <div className="confirm-body">
        <div className="confirm-icon-wrap">
          <BsExclamationCircle className="confirm-icon" />
        </div>

        <div className="confirm-text">
          <h3 className="confirm-title">
            Are you sure you want to login as {selectedClient?.name}'s{" "}
            administrator
          </h3>
          <p className="confirm-description">Please confirm to proceed</p>
        </div>
      </div>

      <div className="confirm-footer">
        <Button className="confirm-btn-cancel" onClick={handleCancel}>
          No
        </Button>

        <Button
          className="confirm-btn-confirm"
          onClick={handleConfirm}
          loading={isLoading}
        >
          Yes
        </Button>
      </div>
    </Modal>
  );
}
